import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/globals.css'
import { installConsoleGuards } from './utils/consoleSanitizer.js'


// Install console guards early
try {
  const enabledRaw = (import.meta.env.VITE_CONSOLE_CLEARED ?? import.meta.env.CONSOLE_CLEARED ?? 'TRUE')
  const enabled = String(enabledRaw).trim().toLowerCase() === 'true'
  if (enabled) {
    installConsoleGuards({
      environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
      autoClearIntervalMs: 15000,
      clearOnNavigation: true,
      // Allowlist any important namespaces you still want to see in prod logs:
      allowlistNamespaces: ['app:critical', 'security:notice'],
      suppressLevels: ['log', 'info', 'debug', 'warn'],
    })
  }
} catch (_) {}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 